import script from "./PairGame.vue?vue&type=script&setup=true&lang=js"
export * from "./PairGame.vue?vue&type=script&setup=true&lang=js"

import "./PairGame.vue?vue&type=style&index=0&id=01a939d0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01a939d0"]])

export default __exports__